<script>
  import { onMount, getContext, tick } from 'svelte';
  import { slide } from "svelte/transition"
  import { createPostRequest } from '../../../src/create_request'
  import { scrollTo, scrollRef, scrollTop } from 'svelte-scrolling'
  import { cart, settings } from '../../../src/data_storage.js'
  settings.useLocalStorage()
  cart.useLocalStorage()

  import InputField from '../../inputs/input_field.svelte'
  import { _, locale, locales } from 'svelte-i18n'
  import { focus, formatCurrency } from '../../../src/utils'
  import SuccessIcon from './svg/success_icon.svelte'
  import ErrorIcon from './svg/error_icon.svelte'
  import InfoIcon from './svg/info_icon.svelte'

  export let shop
  export let order
  export let done_handler
  export let paynow_handler
  export let done_paying_handler
  const { imageUrl, theme } = getContext('app')

  let show = false
  let showPaymentDetail = false
  let errors = null
  let clientSecret
  let stripe = null
  let elements
  let submitButton
  let buttonText = 'Pay now'
  let loading = false
  let paymentMessage = null
  let paymentIntentDetail = null
  let statusText
  let statusIconColor

  function appearanceTheme() {
    if (theme() === 'light') {
      return 'stripe'
    } else {
      return 'night'
    }
  }

  function createIntent() {
    fetch(createPostRequest('/cart/checkout_intent.json',
                        'POST',
                        JSON.stringify({ slug: shop.slug, order_id: order.id })))
      .then(response => response.json())
      .then(data => {
        // console.log('checkout_intent:' + shop.slug)
        // console.log(data)
        if (data.errors) {
          alert(data.errors)
          errors = data.errors
        } else if (data.clientSecret) {
          clientSecret = data.clientSecret
          // [DEV] For demo purposes only
          //setDpmCheckerLink(dpmCheckerLink);
          document.querySelector("#dpm-integration-checker").href = data.dpmCheckerLink

          const appearance = {
            theme: appearanceTheme()
          }

          elements = stripe.elements({ appearance, clientSecret })

          const paymentElementOptions = {
            layout: "accordion"
          }

          const paymentElement = elements.create("payment", paymentElementOptions)
          paymentElement.mount("#payment-element")

        } else {
          errors = ["Something went wrong, try again later."]
        }
      })
      .catch(err => {
        alert('error ' + err)
      })
  }

  onMount(async () => {
    // console.log("fiatPay onMount " + shop.slug)
    // Get query string from URL
    const urlParams = new URLSearchParams(window.location.search)
    const completion = urlParams.get('completion')
    const payment_intent = urlParams.get('payment_intent')
    const payment_intent_client_secret = urlParams.get('payment_intent_client_secret')
    const redirect_status = urlParams.get('redirect_status')

    stripe = Stripe(shop.stripe_publishable_key)

    if (completion && completion == order.id) {
      if (payment_intent_client_secret) {
        checkStatus(payment_intent_client_secret)
      } else {
        setErrorState()
      }
    } else {
      createIntent()
      show = true
    }
  })

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    if (paynow_handler) {
      paynow_handler()
    }

    // Let's have Stripe come back here, where it came from
    let paymentCompletionUrl = new URL(window.location.href)
    paymentCompletionUrl.searchParams.append('completion', order.id)

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: paymentCompletionUrl.href,
      },
    })

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
      showMessage(error.message)
    } else {
      showMessage("An unexpected error occurred.")
    }

    setLoading(false)
  }

  // ------- UI helpers -------
  function showMessage(messageText) {
    paymentMessage = messageText

    setTimeout(function () {
      paymentMessage = null
    }, 4000)
  }

  // Show a spinner on payment submission
  function setLoading(isLoading) {
    if (isLoading) {
      // Disable the button and show a spinner
      loading = true
    } else {
      loading = false
    }
  }

  function setPaymentDetails(intent) {
    paymentIntentDetail = intent
    showPaymentDetail = true

    if (done_paying_handler) {
      if (paymentIntentDetail.status === 'succeeded') {
        done_paying_handler(intent)
      }
    }
  }

  function setErrorState() {
    showPaymentDetail = true
  }

  // Fetches the payment intent status after payment submission
  async function checkStatus(clientSecret) {
    const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret)

    setPaymentDetails(paymentIntent)
  }

  function handle_done() {
    if (done_handler) {
      done_handler()
    }
  }
</script>
<style type="text/css">
div.body {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

form.stripe {
  width: 90vw;
  align-self: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 7px;
  margin-top: auto;
  margin-bottom: auto;
}

#payment-message {
  color: rgb(105, 115, 134);
  font-size: 16px;
  line-height: 20px;
  padding-top: 12px;
  text-align: center;
}

#payment-element {
  margin-bottom: 24px;
}

/* Buttons and links */
button.stripe {
  background: #0055DE;
  font-family: Arial, sans-serif;
  color: #ffffff;
  border-radius: 4px;
  border: 0;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
}
button.stripe:hover {
  filter: contrast(115%);
}
button.stripe:disabled {
  opacity: 0.5;
  cursor: default;
}

/* spinner/processing state, errors */
.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}
.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}
.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: #0055DE;
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  -webkit-transform-origin: 10.4px 10.2px;
  transform-origin: 10.4px 10.2px;
  -webkit-animation: loading 2s infinite ease 1.5s;
  animation: loading 2s infinite ease 1.5s;
}
.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: #0055DE;
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  -webkit-transform-origin: 0px 10.2px;
  transform-origin: 0px 10.2px;
  -webkit-animation: loading 2s infinite ease;
  animation: loading 2s infinite ease;
}

/* dynamic payment methods annotation */
#dpm-annotation {
  align-self: center;
  color: #353A44;
  width: 30vw;
  min-width: 500px;
  line-height: 20px;
  margin-bottom: 20px;
}

#dpm-integration-checker {
  display: inline;
  color: #533AFD;
}

/* Payment status page */
#payment-status {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  row-gap: 30px;
  width: 30vw;
  min-width: 500px;
  min-height: 380px;
  align-self: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 7px;
  padding: 40px;
  opacity: 0;
  animation: fadeInAnimation 1s ease forwards;
}

#status-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
}

h2 {
  margin: 0;
  color: #30313D;
  text-align: center;
}

a {
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  font-family: Arial, sans-serif;
  display: block;
}
a:hover {
  filter: contrast(120%);
}

#view-details {
  color: #0055DE;
}

#retry-button {
  text-align: center;
  background: #0055DE;
  color: #ffffff;
  border-radius: 4px;
  border: 0;
  padding: 12px 16px;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
}

@-webkit-keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes fadeInAnimation {
  to {
      opacity: 1;
  }
}

@media only screen and (max-width: 600px) {
  form.stripe, #dpm-annotation, #payment-status{
    width: 80vw;
    min-width: initial;
  }
}
</style>

<div class="body">
  {#if showPaymentDetail}
    <div class="flex flex-col justify-center items-center">
      {#if paymentIntentDetail}
        {#if paymentIntentDetail.status === 'succeeded'}
          <div class="rounded border p-4 bg-[#30B130]"><SuccessIcon/></div>
          <div class="mt-2">Payment succeeded, thank you!</div>
        {:else if paymentIntentDetail.status === 'processing'}
          <div class="rounded border p-4 bg-[#6D6E78]"><InfoIcon/></div>
          <div class="mt-2">Your payment is processing.</div>
        {:else if paymentIntentDetail.status === 'requires_payment_method'}
          <div class="rounded border p-4 bg-[#DF1B41]"><ErrorIcon/></div>
          <div class="mt-2">Your payment was not successful, please try again.</div>
        {/if}
        <div id="view-details"><a href="https://dashboard.stripe.com/payments/{paymentIntentDetail.id}">View details</a></div>
        <div class="mt-12"><button class="btn" on:click={handle_done}>Continue shopping...</button></div>
      {:else}
        <ErrorIcon/>
        <div>Something went wrong, please try again.</div>
      {/if}
    </div>
  {:else if show}
    <!-- Display a payment form -->
    <form id="payment-form" class="stripe" on:submit={handleSubmit}>
      <div id="payment-element">
        <!--Stripe.js injects the Payment Element-->
      </div>
      <button id="submit" class="stripe" disabled={loading} bind:this={submitButton}>
        {#if loading}
          <div class="spinner" id="spinner"></div>
        {:else}
          <span id="button-text">{buttonText}</span>
        {/if}
      </button>
      {#if paymentMessage}
        <div id="payment-message" class="hidden">{paymentMessage}</div>
      {/if}
    </form>
    <!-- [DEV]: For demo purposes only, display dynamic payment methods annotation and integration checker -->
    <div id="dpm-annotation">
      <p>
        Payment methods are dynamically displayed based on customer location, order amount, and currency.&nbsp;
        <a href="#" target="_blank" rel="noopener noreferrer" id="dpm-integration-checker">Preview payment methods by transaction</a>
      </p>
    </div>
  {/if}
</div>
